import { useServices } from 'core/services';
import { BaseHttpError } from 'core/services/api/errors';
import { GroupsResponse } from 'core/services/api/response-types';
import { Group } from 'core/types';
import { getPageParams } from 'core/utils/pagination';
import { communityKeys } from 'core/utils/query-key-factory';
import { useInfiniteQuery, InfiniteData } from '@tanstack/react-query';

export const useGetCommunityGroups = (communityId: string) => {
	const { api, authentication } = useServices();
	const isLoggedIn = authentication.isAuthenticated();

	return useInfiniteQuery<
		GroupsResponse,
		BaseHttpError,
		InfiniteData<Group[]>
	>({
		queryKey: communityKeys.groups(communityId),
		queryFn: ({ pageParam = undefined, signal }) => {
			return api.getGroups(communityId, {
				pagination: pageParam as any,
				signal,
			});
		},
		initialPageParam: undefined,
		enabled: !!communityId && isLoggedIn,
		select: response => {
			return {
				pages: response.pages.map(page => page.data),
				pageParams: response.pageParams,
			};
		},
		getPreviousPageParam: firstPage =>
			getPageParams(firstPage.pagination).previousParam,
		getNextPageParam: lastPage =>
			getPageParams(lastPage.pagination).nextParam,
		refetchOnMount: true,
		placeholderData: previousData => previousData,
	});
};
